import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-info-skeleton',
    templateUrl: './info-skeleton.component.html',
    styleUrls: ['./info-skeleton.component.scss'],
})
export class InfoSkeleton {

    public theme_bars_base = {
        "background-color": "#e5e5e5",
    };

    public theme_buttons = {
        "background-color": "#e5e5e5",
        width: "2rem",
        height: "2rem",
        "border-radius": "50%",
    };

    @Input() count: number = 5;

    constructor() { }

    public theme_bars(width: number) {
        return {
            ...this.theme_bars_base,
            width: `${width}%`,
        };
    }
}
